import { OtpSendLimitError, OtpSendThrottledError } from '@/shared/domain'

type SendOtpAuthError = { status?: number; code?: string; message?: string }

const MIN_RETRY_SECONDS = 1
const MAX_RETRY_SECONDS = 300
const RETRY_AFTER_PATTERN = /after\s+(\d+)\s+seconds?/i
const RATE_LIMIT_CODES: ReadonlySet<string> = new Set([
  'over_email_send_rate_limit',
  'over_sms_send_rate_limit',
  'over_request_rate_limit',
])

function parseRetryAfterSeconds(message: string | undefined): number | undefined {
  if (!message) return undefined
  const match = RETRY_AFTER_PATTERN.exec(message)
  if (!match) return undefined
  const seconds = Number(match[1])
  if (!Number.isFinite(seconds)) return undefined
  return Math.min(MAX_RETRY_SECONDS, Math.max(MIN_RETRY_SECONDS, Math.trunc(seconds)))
}

function isTwilioSendCap(error: SendOtpAuthError): boolean {
  if (error.status !== 422 || error.code !== 'sms_send_failed') return false
  const message = (error.message ?? '').toLowerCase()
  return message.includes('max send attempts') || message.includes('60203')
}

function isThrottle(error: SendOtpAuthError): boolean {
  return error.status === 429 || (error.code !== undefined && RATE_LIMIT_CODES.has(error.code))
}

export function classifySendOtpRefusal(
  error: SendOtpAuthError,
  channel: 'phone' | 'email',
): OtpSendLimitError | OtpSendThrottledError | null {
  if (channel === 'phone' && isTwilioSendCap(error)) {
    return new OtpSendLimitError()
  }
  if (isThrottle(error)) {
    return new OtpSendThrottledError(channel, parseRetryAfterSeconds(error.message))
  }
  return null
}
